import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminFinance = lazy(() => import("@/pages/admin/AdminFinance"));

export const Route = createFileRoute("/admin/finance")({
  component: AdminFinance,
});
